const t = (s: string): string => { return s }

export default t
